import api from '../../plugins/api';

const getServiceStatuses = (params) => {
  return api.get('/api/crm/services/getServiceStatuses', params);
};

export default getServiceStatuses;
